import React from "react";

const LandingPage = () => (
  <div>
    
      {/* <h2>{localStorage.getItem('auth')}</h2> */}
    <h4>Hey There, Welcome to DeliveryTalla</h4>
  
    {/* <p>This page is public, accessible by everyone</p> */}

    <p>
      What are you waiting for, Just LogIn and Start Ordering Items form your favourite store in your city now...
    </p>
    <p>
      Steps:<br/>
      1: Login to the DeliveryTalla............... <br/>
      2: Select your favourite shop <br/>
      3: Type what item you want <br/>
      4: Confirm the address and Checkout <br/>
      5: We will be ther at you address in No Time <br/>
    </p>
   
    <p>NOTE: We will not take any extra charge, It depends on you how much you want to give us as the delivery Fee !</p>

    <p>
      SO WHAT ARE YOU WAITING FOR, JUST LOGIN ..!
    </p>  
  </div>
);

export default LandingPage;
